<div class="projects-issue-container p-2">
  <div class="d-flex justify-content-between align-items-start pb-3 mb-4 border-bottom">
    <div class="download-button-container">
      <p class="small text-muted fw-500 mb-3">Issues found during our tests.</p>
      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="exportExcelIssues()">
        <i class="fa fa-solid fa-download me-2"></i>Export Excel
      </button>
    </div>
    <div class="legend-container">
      <div class="legend-header">Legend</div>
      <div class="legend-items">
        @for (item of legendOptions; track item) {
          <div class="legend-item">
            <div class="legend-color-box" [style.background-color]="item.color"></div>
            <span class="legend-label">{{ item.label }}</span>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="row g-3 mb-4 p-3 bg-light rounded">
    <div class="col-md-2">
      <select-field
        [selectFormControl]="priorityFilterControl"
        [options]="priorityOptions"
        label="Priority">
      </select-field>
    </div>
    <div class="col-md-2">
      <select-field
        [selectFormControl]="jurisdictionFilterControl"
        [options]="jurisdictionOptions"
        label="Jurisdiction">
      </select-field>
    </div>
    <div class="col-md-2">
      <select-field
        [selectFormControl]="workingListFilterControl"
        [options]="workingListOptions"
        label="Working List">
      </select-field>
    </div>
    <div class="col-md-2">
      <select-field
        [selectFormControl]="statusFilterControl"
        [options]="statusOptions"
        label="Status">
      </select-field>
    </div>
    <div class="col-md-2">
      <select-field
        [selectFormControl]="testNameFilterControl"
        [options]="testNameOptions"
        label="Test Name">
      </select-field>
    </div>
  </div>

  <div class="issues-list">
    @if (projectIssues.length === 0) {
      <div class="alert alert-info mb-0">
        <p class="mb-0">No issues found.</p>
      </div>
    }

    @if (projectIssues.length > 0) {
      <div class="mb-3 small text-muted fst-italic">
        From PM's profile: (issue to be confirmed and priority to be set up)
      </div>
      <div class="d-none d-md-grid issue-header-row mb-2" [style.grid-template-columns]="gridTemplateColumns">
        @for (column of columns; track column) {
          <div class="fw-600 text-white text-center header-cell" [style.text-align]="column.align || 'center'">
            {{ column.label }}
          </div>
        }
      </div>
      @for (issue of projectIssues; track issue) {
        <div class="mb-3">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-3">
              <div class="issue-main-row mb-3" [style.display]="'grid'" [style.grid-template-columns]="gridTemplateColumns" [style.gap]="'0.5rem'" [style.align-items]="'center'">
                <div class="col-verified d-flex justify-content-center">
                  <input type="checkbox" class="form-check-input mt-0"
                    [formControl]="getIssueControls(issue.projectIssueId).verified"
                    (change)="onVerifiedChange(issue, $event)">
                </div>
                <div class="col-priority d-flex align-items-center">
                  <div class="flex-shrink-0" [style.width]="'20px'" [style.height]="'20px'" [style.background-color]="getIssueBorderColor(issue)" [style.border]="'1px solid #dee2e6'" [style.border-radius]="'5px'" ></div>
                  <select-field
                    class="w-100 ms-2"
                    [selectFormControl]="getIssueControls(issue.projectIssueId).priority"
                    [options]="issuePriorityOptions"
                    label=""
                    [readonly]="readonly || !canEditPriority"
                    (selectionChange)="onPriorityChange(issue, $event)">
                  </select-field>
                </div>
                <div class="col-jurisdiction">
                  <input-field
                    [inputFormControl]="getIssueControls(issue.projectIssueId).jurisdiction"
                    label=""
                    [readonly]="true">
                </input-field>
              </div>
              <div class="col-working-list">
                <input-field
                  [inputFormControl]="getIssueControls(issue.projectIssueId).workingListName"
                  label=""
                  [readonly]="true">
              </input-field>
            </div>
            <div class="col-test-name">
              <input-field
                [inputFormControl]="getIssueControls(issue.projectIssueId).testName"
                label=""
                [readonly]="true">
            </input-field>
          </div>
          <div class="col-status">
            <select-field
              [selectFormControl]="getIssueControls(issue.projectIssueId).status"
              [options]="issueStatusOptions"
              label=""
              [readonly]="readonly || !canEditStatus"
              (selectionChange)="onStatusChange(issue, $event)">
            </select-field>
          </div>
          <div class="col-tester">
            <input-field
              [inputFormControl]="getIssueControls(issue.projectIssueId).tester"
              label=""
              [readonly]="true">
          </input-field>
        </div>
        @if (!readonly) {
          <div class="col-actions d-flex justify-content-center gap-1">
            @if (issue.attachments && issue.attachments.length > 0) {
              <button class="btn btn-outline-primary btn-sm" type="button"
                (click)="downloadAttachment(issue)"
                title="Download Attachment">
                <i class="fa fa-solid fa-download"></i>
              </button>
            }
            <button class="btn btn-outline-secondary btn-sm" type="button"
              (click)="openNotesModal(issue)"
              title="Notes">
              <i class="fa fa-solid fa-comment"></i>
            </button>
            @if (canDeleteIssue) {
              <button class="btn btn-outline-danger btn-sm" type="button"
                (click)="confirmDelete(issue)"
                title="Reject">
                <i class="fa fa-solid fa-trash"></i>
              </button>
            }
          </div>
        }
      </div>
      @if (!readonly) {
        <div class="row g-2">
          <div class="col-6">
            <textarea-field
              [textareaFormControl]="getIssueControls(issue.projectIssueId).step"
              label="Step"
              placeholder="Enter step description"
              [readonly]="true"
              [height]="100">
            </textarea-field>
          </div>
          <div class="col-6">
            <textarea-field
              [textareaFormControl]="getIssueControls(issue.projectIssueId).description"
              label="Fail description"
              placeholder="Enter fail description"
              [readonly]="true"
              [height]="100">
            </textarea-field>
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
}
</div>

<ng-template #rejectModalContent let-modal>
  <div class="modal-header bg-light border-bottom">
    <h5 class="modal-title fw-600">Reject Issue</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-2">The issue will be deleted and the member that created it will be notified by email with the reason below.</p>
    <textarea-field
      [textareaFormControl]="rejectReasonControl"
      label="Reason *"
      placeholder="Describe why the issue is not a fail"
      [height]="120">
    </textarea-field>
  </div>
  <div class="modal-footer bg-light border-top">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-danger" [disabled]="rejectReasonControl.invalid" (click)="deleteIssue()">Reject</button>
  </div>
</ng-template>

<ng-template #notesModalContent let-modal>
  <div class="modal-header bg-light border-bottom">
    <h5 class="modal-title fw-600">Issue Notes</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if (selectedIssueForNotes) {
      <notes-customers-form
        [customer]="issueNotes"
        [readonlyCustomerNotes]="readonly"
        [customerId]="projectId"
        [secondaryId]="selectedIssueForNotes?.projectIssueId"
        [noteServiceMethod]="projectsService"
        [addNoteMethod]="'createProjectIssuesNotes'"
        [deleteNoteMethod]="'deleteProjectIssuesNotes'">
      </notes-customers-form>
    }
  </div>
  <div class="modal-footer bg-light border-top">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>
</div>
